module.exports = __webpack_public_path__ + "img/type_img01.5650053f.png";